import React, {useEffect, useState} from "react";
import Axios from "axios";
import AlertMessages from "../../utils/AlertMessage";
import {Config} from "../../utils/Config";
import {GetProfile, GetTokenHeaders} from "../../common/ReusableFunction";
import TextArea from "antd/es/input/TextArea";
import Divider from "@mui/material/Divider";

function SmsService({handleOpen, sponsors, events}) {
    const [message, setMessage] = useState("");
    const [recipient, setRecipient] = useState("");
    let [loading, setLoading] = useState(false);
    let [errors, setErrors] = useState([]);


    let apiURL = Config.apiURL;
    let headers = GetTokenHeaders();
    const profile = GetProfile();

    useEffect(() => {
        setErrors(errors);
    }, [errors]);


    const handleSubmit = () => {
        const payLoad = {
            message: message,
            recipient: recipient,
            created_by: profile.id,
        };
        submitSms(payLoad).then((r) => false);

        setMessage("");
        setRecipient("");

    };

    const submitSms = async (payLoad) => {
        setLoading(true);
        setErrors([]);
        const res = await Axios.post(apiURL + "send-sms", payLoad, headers);
        if (res.status !== 200) {
            AlertMessages(res.data.status, res.data.message);
        } else {
            const status = res.data.data.status;
            const message = res.data.data.message;
            if (status === 100) {
                AlertMessages(status, message);
            } else {
                AlertMessages(102, message);
            }
            setLoading(false);
        }
    };

    return (
        <div className="bg-white rounded-md mt-3 h-screen overflow-auto">
            <div className="bg-white py-2 ml-2 mr-2 mt-5 rounded-lg flex justify-end">
                <div className="container mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-5">
                        <div className="md:col-span-1 px-4">
                            <div className="text-gray-800 mb-4 text-right"> Draft your message here and choose the
                                recipient
                                category.
                                If you want to address the recipient by name, Kindly use place
                                holder <b>[NAME]</b> which
                                will be replaced by the name of the recipient.
                            </div>
                        </div>
                        <div className="md:col-span-2 px-4">
                            <TextArea
                                placeholder="Enter SMS"
                                onChange={(e) => setMessage(e.target.value)}
                                value={message}
                                autoSize={{minRows: 8, maxRows: 12}}
                                style={{width: "100%"}}
                            />

                            <div className="md:col-span-1 mt-4 -mr-4 px-4">
                                <div className="col-span-1 px-4 -mr-4 flex justify-end">
                                    <label className="px-2 text-sm">Select Recipient:</label>
                                    <select
                                        name="recipient"
                                        value={recipient}
                                        onChange={(e) => {
                                            setRecipient(e.target.value);
                                        }}
                                        required
                                        className="w-64 border border-gray-300 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-500"
                                    >
                                        <option value="">Select Recipient</option>
                                        <option value="All">All</option>
                                        <option value="Sponsors">Sponsors</option>
                                        <option value="Participants">Participants</option>
                                    </select>
                                </div>
                            </div>
                            <Divider/>

                            {!loading && recipient !== "" && message !== "" && message.length > 5 &&
                                <div className="flex justify-end p-2">
                                    <button onClick={handleSubmit}
                                            className="bg-green-600 border rounded-md text-white py-2 px-4 rounded hover:bg-yellow-600">
                                        Submit
                                    </button>
                                </div>
                            }
                        </div>


                    </div>
                </div>
            </div>
        </div>

    );
}

export default SmsService;
